var isMobile;
var currentImageIndex = -1;
var imageIds = new Array();
var fadeSpeed;

//Sizing constants. these determine the value of the CSS property 'background-size' of the selected container
var scalingMode = {
    NONE: 0 //Uses the original image size
    , STRETCH: 1//Sets 'background-size' to '100% 100%'. This stretches the background image to fill the container, discarding the images aspect ratio.
    , COVER: 2 //Sets 'background-size' to 'cover'. This makes the background images fill the entire container while retaining its aspect ratio.
    , CONTAIN: 3//Sets 'background-size' to 'contain'. This scales the bakcground image to the largest size such that both its width and its height can fit inside the content area
}

function isRTL(text) {
    if (!text)//undefined,empty etc.
        return false;

    let rtlChars = [
        /* arabic ranges*/
        '\u0600-\u06FF',
        '\u0750-\u077F',
        '\uFB50-\uFDFF',
        '\uFE70-\uFEFF',
        /* hebrew range*/
        '\u05D0-\u05FF'
    ].join("");
    let regex = new RegExp("[" + rtlChars + "]", "g");
    let found = regex.test(text);
    return found;
}


$(document).ready(function () {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) == false) {
        $('.map iframe').css("pointer-events", "none");

        $('.map').click(function () {
            $('.map iframe').css("pointer-events", "auto");
        });

        $(".map").mouseleave(function () {
            $('.map iframe').css("pointer-events", "none");
        });

        isMobile = false;
    }
    else
        isMobile = true;

    if (window.location.hash) {
        var hash = window.location.hash.replace(/^\//, '');
        hash = hash.replace('/', '');
        var target = $(hash);
        if (target.length) {
            $('html, body').animate({
                scrollTop: target.offset().top
            }, 1000);
        }
    }

    setHeaderText();
    var sliderWelcome = $('#SliderWelcome');
    if (sliderWelcome != undefined && sliderWelcome.length > 0) {
        setsliderWelcomeHeight();
    }

});

function setsliderWelcomeHeight() {
    var sliderWelcome = $('.slider-container');
    var bottom = $(window).scrollTop() + $(window).height()
    var slidertop = sliderWelcome.offset().top;
    var sliderbottom = $(window).height();

    bottom = bottom < sliderbottom ? bottom : sliderbottom;
    var height = Math.abs(bottom - slidertop);
    if (height < 250)
        height = isMobile ? 150 : 800;

    sliderWelcome.css({ "height": height });
    if (height < 800) {
        var items = $('#slider .hero');
        items.each(function (index, item) {
            //hero text position
            var hero = $(item);
            var textHeight = ((bottom - slidertop) / 2);
            hero.css({ "top": textHeight + 'px' });
        });
    }
}

function setHeaderText() {
    var img = $('#headerImg');
    var text = $("header .landing-header-content");
    if (text.length > 0 && img.length > 0) {
        var width = img.innerWidth();
        var height = img.innerHeight();
        if (width > 1500 && height > 500) {
            if (text.length > 0)
                text.css("padding", "8%");
        }
    }
}

$.fn.backgroundCycle = function (options) {
    var settings = $.extend({
        duration: 5000,
        fadeSpeed: 1500,
        backgroundSize: scalingMode.COVER
    }, options);

    $('.slider-image').hide();

    fadeSpeed = settings.fadeSpeed;

    var marginTop = this.css('margin-top');
    var marginRight = this.css('margin-right');
    var marginBottom = this.css('margin-bottom');
    var marginLeft = this.css('margin-left');

    var contents = this;
    var children = this.children()
    imageIds = new Array();

    $.each(children, function (key, value) {
        var image = $(value);
        var id = 'bgImage' + key;
        value.id = id;
        var sizeMode;

        switch (settings.backgroundSize) {
            default:
                sizeMode = settings.backgroundSize;
                break;
            case scalingMode.NONE:
                sizeMode = 'auto';
                break;
            case scalingMode.STRETCH:
                sizeMode = '100% 100%';
                break;
            case scalingMode.COVER:
                sizeMode = 'cover';
                break;
            case scalingMode.CONTAIN:
                sizeMode = 'contain';
                break;
        }

        image.css({
            'background-repeat': 'no-repeat',
            'background-size': sizeMode,
            '-moz-background-size': sizeMode,
            '-webkit-background-size': sizeMode,
            position: 'absolute',
            left: marginLeft,
            top: marginTop,
            right: marginRight,
            bottom: marginBottom,
            'background-position-y': 'center',
            'background-position-x': 'center',

        });

        imageIds.push(id);
    });


    contents.css({
        position: 'absolute',
        left: marginLeft,
        top: marginTop,
        right: marginRight,
        bottom: marginBottom
    });

    this.append(contents);
    $('#' + imageIds[0]).show();
    $('#' + imageIds[0]).addClass('active');
    if (imageIds.length > 1)
        setInterval(cycleToNextImage, settings.duration);
};

function cycleToNextImage() {
    var previousImageId = imageIds[currentImageIndex];
    currentImageIndex++;
    if (currentImageIndex >= imageIds.length) {
        currentImageIndex = 0;
    }
    var options = {
        duration: fadeSpeed,
        queue: false
    };
    $('#' + previousImageId).removeClass("active");
    $('#' + previousImageId).fadeOut(options);
    $('#' + imageIds[currentImageIndex]).fadeIn(options);
    $('#' + imageIds[currentImageIndex]).addClass("active");
}